import { render } from "./ModalSave.vue?vue&type=template&id=17d3e949"
import script from "./ModalSave.vue?vue&type=script&lang=js"
export * from "./ModalSave.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__